import { IDLE } from '../../../../enums/states';
import openedTransactions from './openedTransactions';
import closedTransactions from './closedTransactionsWithoutClosure';
import templates from './templates';
import transactionsStats from './transactionsStats';
import { DASHBOARD_RESET } from '../../../actions/dashboard/dashboard';

const initialState = {
  openedTransactions: null,
  closedTransactions: null,
  templates: null,
  transactionsStats: null,
  error: null,
  state: IDLE,
};

const output = (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD_RESET:
      return initialState;
    default:
      break;
  }

  return {
    ...state,
    openedTransactions: openedTransactions(state.openedTransactions, action),
    closedTransactions: closedTransactions(state.closedTransactions, action),
    templates: templates(state.templates, action),
    transactionsStats: transactionsStats(state.transactionsStats, action),
  };
};

export default output;
